export default {
  title: 'Käyttöoikeudet: {{role}}',
  form: {
    companies: {
      label: 'Näkyvissä kaikille, joilla on rooli {{role}}',
      tooltip: 'Tämä lisätään paikkoihin, joihin tiimin jäsen rekisteröityi',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui, päivitä sivu',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
